/**
 * 單據「退回／刪除草稿」固體深底淺字；與全域 Button variant="destructive" 同款（見 commonComponents/button/Button.jsx）。
 * 覆蓋 shadcn destructive＝`bg-destructive/10 text-destructive`。
 */
export const DESTRUCTIVE_SOLID_BUTTON_CLASS = 'bg-red-600 text-red-50 hover:bg-red-700 hover:text-white';
